import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthResourceService, ServiceResponse } from '../../../../resource-module';
import { FormValidators as Validators } from '../../../../forms';

@Component({
    selector: 'forgot-password-dialog',
    templateUrl: './forgot-password.dialog.html',
    styleUrls: ['./forgot-password.dialog.scss']
})
export class ForgotPasswordDialog {

    public message: string = '';

    public pending: boolean = false;

    public state: number = 0;

    public passwordForm:FormGroup = new FormGroup({
        username: new FormControl('', [Validators.required, Validators.email])
    });

    private email: string = "";
    public confirmMessage: string = '';

    public confirmPasswordForm:FormGroup = new FormGroup({
        code: new FormControl('', [Validators.required]),
        password: new FormControl('', [
            Validators.required,
            Validators.passwordPattern,
            Validators.minLength(8),
            Validators.maxLength(255),
            Validators.syncWith('confirmPassword')
        ]),
        confirmPassword: new FormControl('', [
            Validators.required,
            Validators.matchField('password')
        ])
    });

    constructor(
        protected _dialogRef: MatDialogRef<any>,
        protected _router: Router,
        protected _authResourceService: AuthResourceService
    ) {}

    public returnToLogin() {
        this._dialogRef.close({sendToLogin: true, message: "Password change successful."});
    }

    public submitForgotten() {
        this.message = '';
        this.pending = true;
        this._authResourceService.forgotPassword(this.passwordForm.value['username']).subscribe((response: ServiceResponse) => {
            // Don't want to give away whether or not the request succeeded to prevent farming for emails or spamming reset requests.
            this.state = 1;
            this.pending = false;
            this.email = this.passwordForm.value['username'];
        });
    }

    public toggleInputType(fieldId) {
        let elem = document.getElementById(fieldId);
        let newType = elem.getAttribute("type") === "password" ? "text" : "password";
        elem.setAttribute("type", newType)
    }

    public closeModal() {
        this._dialogRef.close();
    }

    public submitConfirm() {

        let values = this.confirmPasswordForm.value;
        this.confirmMessage = '';

        // TODO what do if user does not have validation code? (did not follow link provided in email).
        if(this.email.length == 0 || values['code'].length == 0) {
            return;
        }

        if(!values['password'] === values['confirmPassword']) {
            this.confirmMessage = 'Passwords do not match';
            return;
        }

        this._authResourceService.confirmForgotPassword(this.email, values['code'], values['password']).subscribe((response: ServiceResponse) => {
            if (response.success) {
                this.returnToLogin();
            } else {
                this.confirmMessage = response.message;
            }
        });
    }

}
